import { styled } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers-pro';

type ExtraProps = { inWeek: boolean; first: boolean; last: boolean };

export const StyledPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) =>
    prop !== 'inWeek' && prop !== 'first' && prop !== 'last'
})<ExtraProps>(({ theme, inWeek, first, last }) => ({
  ...(inWeek && {
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    borderRadius: 0,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.default
    }
  }),
  ...(first && {
    borderTopLeftRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius
  }),
  ...(last && {
    borderTopRightRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius
  })
}));
